mutation incrPageViewMetric($heading: String, $userType: UserTypeEnum, $brandId: ID, $page: String, $customerId: ID) {
  incrPageViewMetric(heading: $heading, userType: $userType, brandId: $brandId, page: $page, customerId: $customerId)
}
